import { ref, unref } from 'vue';
import SalesTransactionsAPI from 'dashboard/api/salesTransactions';

const checkId = check =>
  String(check?.id ?? check?.id_correcao ?? check).trim();

const errorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.error || fallback;

export function useSalesReviewCheckCompletion({ id, transaction, notify, t }) {
  const saving = ref(false);

  const save = async ({ section, targetKey = '', checks = [] }) => {
    const checkIds = checks.map(checkId).filter(Boolean);
    if (!checkIds.length) return true;

    saving.value = true;
    try {
      const response = await SalesTransactionsAPI.saveReviewChecks(unref(id), {
        section,
        target_key: targetKey,
        check_ids: checkIds,
      });
      if (transaction) transaction.value = response?.data || transaction.value;
      return true;
    } catch (error) {
      notify(errorMessage(error, t('SALES.REVIEW.ERRORS.RESUBMIT')));
      return false;
    } finally {
      saving.value = false;
    }
  };

  return { save, saving };
}
